import React from 'react'
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Navbar from './componnents/Navbar'
import Footer from './componnents/footer/Footer';
// import Carousels from './componnents/carousels/Carousels'; 
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./home/Home";
import About from "./about/About";
import Contact from './contact/Contact';
import View from '../src/view/View';
import Infrastructure from './infrastructure/Infrastructure';
import Products from './products/Products'
// import {GlobalStyle} from "./GlobalStyle";
import { ThemeProvider } from "styled-components";
// import Hero from "./home/Hero";
import {GlobalStyle} from "./GlobalStyle";
import View2 from './view2/View2';
import View3 from './view3/View3';
// import Navbar3 from './componnents/Navbar3';
// import Todo from './componnents/todo/Todo';



 export const App = () => {




  const theme = {
    colors: {
      bg: "#F6F8FA",
      footer_bg: "#0a1435",
      btn: "rgb(98 84 243)",
      border: "rgba(98,84,243,0.5)",
      hr: "#ffffff",
      gradient:
      "linear-gradient(0deg,rgb(132 144 255) 0%, rgb(98 189 252) 100%)",
      shadow:
      "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27,31,35,0.15) 0px 0px 0px 1px;",
      shadowSupport: "rgba(0,0,0,0.16) 0px 1px 4px",
    },
    media:{
      mobile: "768px",
      tab: "998px",
    }
  };





  return (

    <ThemeProvider theme={theme}>
   <Router>
   { <GlobalStyle/> }
   <Navbar />
  
   
   {/* <Carousels /> */}
   <Routes>
   
   {/* <Route path="/home" element={<Home />}/> */}
   <Route path="/" element={<Home />} />
   {/* <Route path="/" element={<Hero />} /> */}
   <Route path="/About" element={<About />} />
   <Route path="/Contact" element={<Contact />} />
   <Route path="/View" element={<View />} />
   <Route path="/View2" element={<View2 />} />
   <Route path="/View3" element={<View3 />} />
   <Route path="/Infrastructure" element={<Infrastructure />} />
   <Route path="/Products" element={<Products />} />

   {/* <Route path="/Todo" element={<Todo />} /> */}
   </Routes>
   <Footer />
   </Router>
   </ThemeProvider>
  )
}

export default App
